import { service } from "../../../services";
import moment from "moment";
const uuid = require("uuid/v4");

const state = {
  items: [],
  offer: {},
  error: null
};

const mutations = {
  setOffers(state, offer) {
    state.items = offer;
  },

  newOffer(state, offer) {
    state.items.push(offer);
  },

  updateOffer(state, offer) {
    let currentOffer = state.items.find(o => {
      return offer.id == o.id;
    });

    if (!currentOffer) {
      state.items.splice(currentOffer, 1, offer);
    }
  },

  deleteOffer(state, id) {
    let currentOffer = state.items.find(o => {
      return id == o.id;
    });

    if (currentOffer != -1) {
      state.items.splice(currentOffer, 1);
    }
  },

  editOfferData(state, offer) {
    state.editOffers.push(offer);
  },

  setOfferInfo(state, offer) {
    state.offer = offer;
  },

  deleteAll(state) {
    state.ownOffers = [];
  },

  setError(state, error) {
    state.error = error;
  }
};

const actions = {
  async fetchOffers({ commit }) {
    const res = await service.get("/listed_offers");
    commit("setOffers", res.items);
  },

  async fetchRawOffers({ commit }, page) {
    const res = await service.get(`/offers?page=${page}`);
    commit("setOffers", res.items);
  },

  async addOffer({ dispatch, commit }, payload) {
    console.log(payload);
    let offer = {
      merchant: {
        id: payload.merchant.id,
        logo: payload.merchant.logo,
        type: "merchant"
      },
      owner: {
        id: payload.owner.id,
        type: "merchant"
      },
      applies: payload.applies,
      category: payload.category,
      code: payload.code,
      dates: payload.dates.map(date => {
        return {
          daily: false,
          endDate: date.end,
          endTime: `${date.start.hour()}:${date.start.minute()}`,
          rid: uuid(),
          startDate: date.start,
          startTime: `${date.start.hour()}:${date.start.minute()}`
        };
      }),
      description: payload.description,
      exclusive: false,
      image: payload.image,
      _attachments: payload._attachments,
      finish: moment(payload.dates[payload.dates.length - 1].end).format(
        "YYYY-MM-DD"
      ),
      id: payload.id,
      terms: `${payload.terms} `,
      tiles: payload.tiles,
      title: payload.title,
      pricing: payload.pricing.map(price => {
        if (!price.tribe) {
          return {
            discount: price.discount,
            id: null,
            previous: price.previous,
            price: price.price,
            type: "tribe"
          };
        } else {
          return {
            discount: price.discount,
            id: price.tribe.id,
            previous: price.previous,
            price: price.price,
            type: "tribe"
          };
        }
      }),
      start: moment(payload.dates[0].startDate).format("YYYY-MM-DD"),
      tagline: payload.tagline,
      tribes: payload.pricing.map(price => {
        if (!price.tribe) {
          return {
            id: null,
            type: "tribe"
          };
        }

        return {
          id: price.tribe.id,
          type: "tribe"
        };
      }),
      source: {},
      demographic: {},
      type: "offer"
    };

    try {
      let res = await service.put(`/offers/${offer.id}`, offer);
      commit("newOffer", res.data.item);
      dispatch("cropper/clear", { root: true });
    } catch (err) {
      commit("setError", err.message);
    }
  },

  async searchOffer({ commit }, searchTerm) {
    try {
      const searchOffer = await service.get("/listed_offers?=" + searchTerm);
      commit("setOffers", searchOffer);
    } catch (err) {
      commit("setError", err);
    }
  },

  fetchCategoryOffers({ commit }, categoryOffer) {
    try {
      return service.get("/listed_offers?category=" + categoryOffer);
    } catch (err) {
      commit("setError", err);
    }
  },

  async updateOffer({ commit }, offer) {
    offer.merchant = {
      id: offer.merchant.id,
      type: offer.merchant.type
    };

    if (offer.pricing && offer.pricing.length > 1) {
      let pricing = offer.pricing.map(price => {
        if (!price.tribe) {
          return {
            discount: price.discount,
            id: null,
            previous: price.previous,
            price: price.price,
            type: "tribe"
          };
        } else {
          return {
            discount: price.discount,
            id: price.tribe.id,
            previous: price.previous,
            price: price.price,
            type: "tribe"
          };
        }
      });
      offer.start = payload.dates[0].start.format("YYYY-MM-DD");
      offer.finish = payload.dates[0].end.format("YYYY-MM-DD");
      offer.pricing = pricing;
    }

    try {
      commit("updateOffer", offer);
      await service.patch(`/offers/${offer.id}`, offer);
    } catch (err) {
      commit("setError", err);
    }
  },

  async deleteOffer({ commit }, offer) {
    try {
      commit("deleteOffer", offer);
      await service.remove(`/offers/${offer.id}`);
    } catch (err) {
      commit("setError", err);
    }
  },

  showInfo({ commit }, offer) {
    commit("setOfferInfo", offer);
  },

  async searchResults({ commit }, data) {
    console.log(data);
    commit("setOffers", data);
  }
};

export const offers = {
  namespaced: true,
  state,
  actions,
  mutations
};
